import { OfflineScreen } from "@/components/offline/offline-screen";
import { env } from "@/constants/env";
import { renderWithProviders } from "./render-with-providers";
import { retryConnection } from "./retry-connection";
import { setupViewport } from "./setup-viewport";

interface OfflineViewState {
  isChecking: boolean;
  errorMessage?: string;
}

let offlineViewState: OfflineViewState = {
  isChecking: false,
};

export const renderOfflineShell = async (
  overrides: Partial<OfflineViewState> = {},
): Promise<void> => {
  offlineViewState = {
    ...offlineViewState,
    ...overrides,
  };

  // Neutralize Android edge-to-edge margins in the background (render no longer awaits
  // this). The offline screen is full-screen, so it need not block first paint.
  void setupViewport();

  await renderWithProviders(
    <OfflineScreen
      remoteUrl={env.VITE_REMOTE_APP_URL}
      isChecking={offlineViewState.isChecking}
      errorMessage={offlineViewState.errorMessage}
      onRetry={retryConnection}
    />,
  );
};
